import { mapState } from 'vuex';
import * as mutationTypes from '@/vuex/mutation-types';

export default {
    computed: {
        ...mapState({
            httpStatus: state => state.httpStatus,
            alertData: state => state.alertData,
            pageData: state => state.pageData,
        }),
    },
    created() {},
    methods: {
        /**
         * 所有欄位驗證
         * @param {Function} callback 驗證通過回呼
         */
        validateForm(callback) {
            this.$store.dispatch(mutationTypes.pageData.setIsFirstEdit, false);
            this.$validator.validateAll().then((isValid) => {
                // console.log('驗證有無通過', isValid);
                if (!isValid) {
                    // eslint-disable-next-line no-alert
                    this.commonAlert('請填寫必填欄位或格式錯誤！');
                    return;
                }
                if (callback) callback();
            });
        },
        /**
         * 清除欄位驗證
         */
        clearValidate() {
            this.errors.clear();
            this.$store.dispatch(mutationTypes.pageData.setIsFirstEdit, true);
        },
        /**
         * 設定loading值
         * @param {Boolean} isLoading 是否載入中
         */
        setLoading(isLoading) {
            this.$store.dispatch(mutationTypes.pageData.setIsLoading, isLoading);
        },
        /**
         * request 錯誤處理
         * @param {Object} err 錯誤物件
         */
        errorHandler(err) {
            if (err) {
                switch (err.response.status) {
                case 400:
                case 403:
                case 404:
                case 500:
                    this.$store.dispatch(mutationTypes.httpStatus.setIsShow,
                        !this.httpStatus.isShow);
                    this.$store
                        .dispatch(mutationTypes.httpStatus.setStatusCode, err.response.status);
                    break;
                default:
                    this.$store
                        .dispatch(mutationTypes.httpStatus.setStatusCode, err.response.status);
                    break;
                }
                // eslint-disable-next-line no-console
                console.log('ErrorHandler: ', err);
                this.setLoading(false);
            }
        },
        /**
         * 客製提示視窗
         * @param {String} msg 文字訊息
         * @param {Function} callback 回呼
         * @param {Boolean} isShowCancelBtn 是否出現取消按鈕
         */
        commonAlert(msg, callback, isShowCancelBtn) {
            this.$store.dispatch(mutationTypes.alertData.setMsg, msg);
            this.$store.dispatch(mutationTypes.alertData.setIsShow, !this.alertData.isShow);
            this.$store.dispatch(mutationTypes.alertData.setCallback, callback);
            this.$store.dispatch(mutationTypes.alertData.setIsShowCancelBtn, isShowCancelBtn);
        },
        goPage(routerName) {
            // const targetDate = new Date('2020-02-01 00:00:00');
            // const now = new Date();

            if ((routerName === 'ActivityDetail' || routerName === 'Activity')) {
                this.commonAlert('活動已於2020/1/31結束，中獎名單於2020/2/12公布，敬請期待', this.goProductPage);
                return;
            }

            if (routerName.match('/')) {
                this.$router.push({ path: routerName });
            } else {
                this.$router.push({ name: routerName });
            }
            window.scroll(0, 0);
        },
        // 前往產品頁
        goProductPage() {
            this.goPage('Product');
        },
        scrollToTop(scrollDuration) {
            const scrollStep = -window.scrollY / (scrollDuration / 15);
            const scrollInterval = setInterval(() => {
                if (window.scrollY !== 0) {
                    window.scrollBy(0, scrollStep);
                } else {
                    clearInterval(scrollInterval);
                }
            }, 15);
        },
        gaEvent(category, label) {
            this.$gtag.event('點擊', { event_category: category, event_label: label });
        },
    },
    filters: {},
    components: {
    },
};
